import React from 'react';
import Icon from '../Icon';

function TextBadge({
  title = 'Upto 10% OFF',
  gradientColorStart = '#E94D31',
  gradientColorEnd = '#E94D31',
}) {
  return (
    <div
      className="flex items-center w-fit h-[32px] p-8 py-6 bg-text-offer rounded-[4px] rounded-bl-none relative"
      style={{
        background: `linear-gradient(to right, ${gradientColorStart}, ${gradientColorEnd})`,
      }}
    >
      <div className="absolute -bottom-[8px] left-0 w-[8px] h-[8px] !bg-transparent -rotate-1 transform origin-bottom-left">
        <Icon type="triangle-vector" />
      </div>
      <span className="text-white text-left text-xs font-semibold">
        {title}
      </span>
    </div>
  );
}

export default TextBadge;
